var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"viewsrhwxcommonComponent_waitAndReportShow"},[_vm._v(" "+_vm._s(_vm.textVal)+_vm._s(_vm.timeCacl(_vm.item.create_time))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }